import React, { useState, useEffect } from "react";
import { Table, Tag, Space, Avatar, Text, Tooltip, Spin, Select } from "antd";
//import { Redirect, Link } from "react-redirect";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import getSymbolFromCurrency from "currency-symbol-map";
import CurrencyFlag from "react-currency-flags";
import { Input, Button } from "antd";
import {
  CaretUpOutlined,
  CaretDownOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const Statitics = ({ currencyName }) => {
  const CoinList = (currency) =>
    `https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency}&order=market_cap_desc&per_page=100&page=1&sparkline=false`;

  const [cryptoList, setCryptoList] = useState([]);
  // const [currency, setCurrency] = useState("inr");
  const [searchTerm, setSearchTerm] = useState("");

  async function getCoinData() {
    try {
      const response = await axios.get(CoinList(currencyName));
      setCryptoList(response.data);
      if (searchTerm !== "") {
        const coinData = cryptoList?.filter((item) =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        console.log(cryptoList, "console");
        setCryptoList(coinData);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getCoinData();
    console.log(searchTerm);
  }, [searchTerm, currencyName]);

  const loadingState = cryptoList.length === 0 ? true : false;

  const { Option } = Select;

  const currencyList = [
    "btc",
    "eth",
    "ltc",
    "bch",
    "bnb",
    "eos",
    "xrp",
    "xlm",
    "link",
    "dot",
    "yfi",
    "usd",
    "aed",
    "ars",
    "aud",
    "bdt",
    "bhd",
    "bmd",
    "brl",
    "cad",
    "chf",
    "clp",
    "cny",
    "czk",
    "dkk",
    "eur",
    "gbp",
    "hkd",
    "huf",
    "idr",
    "ils",
    "inr",
    "jpy",
    "krw",
    "kwd",
    "lkr",
    "mmk",
    "mxn",
    "myr",
    "ngn",
    "nok",
    "nzd",
    "php",
    "pkr",
    "pln",
    "rub",
    "sar",
    "sek",
    "sgd",
    "thb",
    "try",
    "twd",
    "uah",
    "vef",
    "vnd",
    "zar",
    "xdr",
    "xag",
    "xau",
    "bits",
    "sats",
  ];

  console.log(currencyName);

  console.log(cryptoList);

  const currencySymbol = getSymbolFromCurrency(currencyName.toUpperCase());

  if (cryptoList === []) return <Spin />;

  const columns = [
    {
      title: "Coin",
      dataIndex: "coin",
      key: "coin",
      render: (coin) => (
        <>
          <Link to={`cryptoStats/${coin[2]}`}>
            <Tooltip title="click to view historical chart data">
              <div
                className="FirstcolumnField"
                style={{
                  display: "flex",
                  alignItems: "space-between",
                }}
              >
                <Avatar src={coin[1]} />
                <h4 style={{ marginTop: "2px", marginLeft: "3px" }}>
                  {" "}
                  {coin[0]}{" "}
                </h4>
              </div>
            </Tooltip>
          </Link>
        </>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (price) => (
        <>
          <p>
            {currencySymbol} {price}
          </p>
        </>
      ),
    },
    {
      title: " Change(24h)",
      dataIndex: "dailychange",
      key: "dailychange",
      render: (dailychange) => (
        <>
          <Tag
            color={dailychange[1]}
            style={{ alignItems: "centre", justifyContent: "center" }}
            width="50px"
          >
            <p
              style={{
                color: dailychange[1],
                marginTop: "5px",
                fontWeight: "bold",
              }}
            >
              {dailychange[2]}
              {dailychange[0]} %
            </p>
          </Tag>
        </>
      ),
    },
    {
      title: "Market Cap",
      dataIndex: "marketcap",
      key: "marketcap",
    },
    {
      title: "Chart",
      dataIndex: "chart",
      key: "chart",
      render: (chart) => (
        <>
          {" "}
          <Link to={`cryptoStats/${chart}`}>
            <Button>View Chart</Button>
          </Link>
        </>
      ),
    },
  ];

  const coindata = [];

  cryptoList?.map((item, index) => {
    let color = item.market_cap_change_percentage_24h > 0 ? "green" : "red";
    let symbol =
      item.market_cap_change_percentage_24h > 0 ? (
        <CaretUpOutlined />
      ) : (
        <CaretDownOutlined />
      );
    const dataObj = {
      key: index,
      coin: [item.name, item.image, item.id],
      price: item.current_price,
      dailychange: [
        item.market_cap_change_percentage_24h.toFixed(2),
        color,
        symbol,
      ],
      marketcap: item.market_cap,
      chart: item.id,
    };
    coindata.push(dataObj);
  });

  const data = [
    {
      key: "1",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      tags: ["nice", "developer"],
    },
    {
      key: "2",
      name: "Jim Green",
      age: 42,
      address: "London No. 1 Lake Park",
      tags: ["loser"],
    },
    {
      key: "3",
      name: "Joe Black",
      age: 32,
      address: "Sidney No. 1 Lake Park",
      tags: ["cool", "teacher"],
    },
  ];
  return (
    <>
      <div className="search-select">
        <Input
          placeholder="Search Coin "
          onChange={(event) => setSearchTerm(event.target.value)}
          style={{
            borderRadius: "10px",
            height: "40px",
            boxShadow: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
          }}
          prefix={<SearchOutlined />}
        />
      </div>
      <div className="table-container">
        <Table
          columns={columns}
          dataSource={coindata}
          loading={loadingState}
          bordered={true}
          showHeader={true}
          pagination={{
            defaultPageSize: 30,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
          }}
          /*   onRow={(record, rowIndex) => {
            return {
              onClick: (event) => <Redirect push to={record.link} />,
            };
          }} */
        />
      </div>
    </>
  );
};

export default Statitics;
